<template>
    <div component="VideoRequestPublic" template="page">
        <div container="main" type="vertical" padding="0" state="edit-" v-if="!loading && !fatalError">
            <video-recorder
                :scriptText="getVideoRequestVideo.script"
                :uploading="uploading"
                :message.sync="response"
                @submit="submitVideo"
            ></video-recorder>
        </div>
    </div>
</template>

<script lang="js">
import VideoRecorder, { defaultVrMessage } from './VideoRecorder.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'VideoRequestPublic',

    components: {
        VideoRecorder,
    },

    data() {
        return {
            videoHash: null,
            loading: true,
            uploading: false,
            fatalError: false,
            response: {
                ...defaultVrMessage,
            },
        };
    },

    async mounted() {
        this.videoHash = this.$route.params.hash;

        try {
            await this.loadVideoRequestDetail({
                hash: this.$route.params.hash,
                character_id: null,
            }).catch((e) => {
                this.$emit('error', e);
                this.$bugsnag.notify(e);
            });
        } catch (e) {
            switch (e.response.status) {
                case 404:
                    this.$router.push({ name: '404' });
                    break;
                default:
                    this.$bugsnag.notify(e);
            }
        } finally {
            this.loading = false;
        }
    },

    methods: {
        ...mapActions(['loadVideoRequestDetail', 'storeVideoRequestVideo']),

        async submitVideo(data) {
            try {
                this.uploading = true;

                const formData = new FormData();

                formData.append('video_hash', this.videoHash);
                formData.append('video', data, data.name);

                await this.storeVideoRequestVideo(formData);

                this.response = {
                    ...defaultVrMessage,
                    visible: true,
                    message: 'Video was successfuly uploaded and processing in background.',
                };
            } catch (e) {
                this.response = {
                    ...defaultVrMessage,
                    visible: true,
                    message: 'Error while uploading video, try again.',
                    error: true,
                };
                this.$bugsnag.notify(e);
            } finally {
                this.uploading = false;
            }
        },
    },

    computed: {
        ...mapGetters(['getVideoRequestVideo']),
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='VideoRequestPublic'] {
    height: 100%;
    max-height: 100%;

    [container='main'] {
        position: inherit;
        max-width: 100%;
        height: 100%;
    }
}
</style>
